export default __webpack_public_path__ + "static/27-ae307e5763f54d5a8b19abf24b8ce9d4.jpg";